import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {//首页
      path: '/',
      name: 'index',
      component: () => import('@/views/index'),
      children: [
        {//首页
          path: '/',
          name: 'home',
          component: () => import('@/views/home')
        },
        {//业务
          path: '/bussiness',
          name: 'bussiness',
          component: () => import('@/views/bussiness')
        },
        {//公司简介
          path: '/company',
          name: 'company',
          component: () => import('@/views/company')
        },
        {//联系我们
          path: '/contactus',
          name: 'contactus',
          component: () => import('@/views/contactus')
        },
        {
          path: '/infomation',
          name: 'infomation',
          component: () => import('@/views/infomation')
        },
        {
          path: '/infomationi',
          name: 'infomationi',
          component: () => import('@/views/infomationi')
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js